/**
 * 運行指示書ページ用のスクリプト
 */

// 一覧
if (is_route('operation_instruction.index')) {
    // コンテンツ読み込み後
    $(document).on('bss:onload', function() {
        operation_instruction_event_set();
        operation_instruction_map_set();
    });

    // コンテンツの再読み込み後
    $(document).on('bss:reload', function() {
        operation_instruction_map_set();
    });
}

// 編集
if (is_route('operation_instruction.instruction_setting') || is_route('operation_instruction.route_master_setting')) {
    // イベントの設定が完了してから処理を開始する
    $(document).on('bss:onload', function() {
        operation_instruction_setting_event_set();
        operation_instruction_setting_map_set();
    });

    // コンテンツの再読み込み後
    $(document).on('bss:reload', function() {
        operation_instruction_setting_map_set();
    });
}

// ルート検索
if (is_route('operation_instruction.route_search')) {
    $(document).on('bss:onload', function() {
        drag_flg = true;
        operation_instruction_setting_map_set();
    });
}

let zMapMain;
let polylineLociLatlon = [];
let polylineLoci = false;
let marker = [];
let msg = [];
let RouteData;
let lineData;
let elapsed_time_total = 0;
let timerId;

let link_data = [];
let detailedTime = [];
let route_list = [];
let drag_flg = false;
let route_search_flg = false;
let create_flg = false;

var llbox,direction;
var mkrLatLon, dragging, difLat, difLon, pl, latlons, timer=null;
var amount=20;

/**
 * 一覧ページ読み込み時のイベント設定
 */
window.operation_instruction_event_set = function() {
    let url = new URL(window.location.href);
    $('div.content-wrapper').css('min-height','100%');

    //運行指示書ボタン
    $(document).on('click', '.operation_instruction_btn', function() {
        action = $(this).data('action');
        $('#search-form').attr('action', action);

        // URLの書き換え（履歴には残さない
        url = new URL(window.location.href);
        url.searchParams.set('mode', 'instruction');
        history.replaceState(null, '', url.pathname + url.search);

        load_contents(null, false);
    });

    //経路マスタボタン
    $(document).on('click', '.route_master_btn', function() {
        action = $(this).data('action');
        $('#search-form').attr('action', action);

        // URLの書き換え（履歴には残さない
        url = new URL(window.location.href);
        url.searchParams.set('mode', 'route');
        history.replaceState(null, '', url.pathname + url.search);

        load_contents(null, false);
    });

    // 検索用フォーム（内容を変更した際に親formが発火しないように改修
    $(document).on('change','[name=list_range]', function(e) {
        e.preventDefault();
        e.stopPropagation();
    });

    // 検索用フォーム（内容を変更した際に親formが発火しないように改修
    $(document).on('change','.search_text_form', function(e) {
        e.preventDefault();
        e.stopPropagation();
    });

    // 各フォームが親formの発火を行わないようにする
    $(document).on('change', '.route_master_parts', function(e){
        e.preventDefault();
        e.stopPropagation();
    });

    // 検索ボタン
    $(document).on('click','#search-btn', function(e) {
        e.preventDefault();
        e.stopPropagation();

        // URLの書き換え（履歴には残さない
        url = new URL(window.location.href);
        action = extend_url_query($('#search-form').attr('action'));
        $('#search-form').attr('action', action);
        history.replaceState(null, '', url.pathname + url.search);

        load_contents(null, false);
    });

    // 編集ボタン（クリックした際に親formが発火しないように改修
    $(document).on('click','.edit_link_btn', function(e) {
        e.stopPropagation();
    });

    // 地図用の要素がリサイズされた場合に地図を表示しなおす
    $(window).on('resize', function(){
        clearTimeout(timerId);
        timerId = setTimeout(() => {
            resizeMap();
        }, 200);
    });
}

window.operation_instruction_map_set = function() {
    //map
    zMapMain = $('#instruction_map').find('.video-map');

    // 初期データ
    RouteData = $('#instruction_map').find('.video-map').data('route_data');

    // 地図：初期表示
    setTimeout(function(){
        createMap();
        deleteRouteData();
        drawRouteData();
        adjustMapZoom();
    },1000);

    //一覧のデータをクリック時に地図上の経路データを書き換える
    $(document).off("click", ".instruction_data");
    $(document).on('click', '.instruction_data', function() {
        $('.highlight').removeClass('highlight');
        $(this).addClass('highlight');
        RouteData = $(this).data('route_data');
        deleteRouteData();
        drawRouteData();
        adjustMapZoom();
        changeRouteDataList();
    });
}

/**
 * 編集ページ読み込み時のイベント設定
 */
window.operation_instruction_setting_event_set = function() {
    $('div.content-wrapper').css('min-height','100%');

    // 各フォームが親formの発火を行わないようにする
    $(document).on('click', '.istruction_parts', function(e){
        e.preventDefault();
        e.stopPropagation();
    });

    // 各フォームが親formの発火を行わないようにする
    $(document).on('change', '#search-form-passenger', function(e){
        e.preventDefault();
        e.stopPropagation();
    });

    calculateElapsedTime();

    $(document).on('change','#operation_instruction-start_time', function(){
        if ($(this).hasClass('route_master_form')) {
            var timeStr = $(this).val();
            var [hours, minutes] = timeStr.split(':').map(Number);
            var newTs = elapsed_time_total + ((hours * 60) + minutes);
            var dislplay_time = createTimeStr(newTs);
            $('#operation_instruction-end_time').val(dislplay_time);
            $('#operation_instruction-end_time-value').val(dislplay_time);
        } else {
            dt = new Date($(this).val());
            var newTs = dt.getTime() + (elapsed_time_total * 60 * 1000);
            $('#operation_instruction-end_time').val(createDateStr(newTs));
        }
    });


    $(document).on('change','#operation_instruction-start_time-value', function(){
        var timeStr = $(this).val();
        var [hours, minutes] = timeStr.split(':').map(Number);
        var newTs = elapsed_time_total + ((hours * 60) + minutes);
        var dislplay_time = createTimeStr(newTs);
        $('#operation_instruction-end_time').val(dislplay_time);
        $('#operation_instruction-end_time-value').val(dislplay_time);
    });

    $(document).on('change','#operation_instruction-end_time', function(){
        if ($(this).hasClass('route_master_form')) {
            var timeStr = $(this).val();
            var [hours, minutes] = timeStr.split(':').map(Number);
            var newTs = ((hours * 60) + minutes) - elapsed_time_total;
            var dislplay_time = createTimeStr(newTs);
            $('#operation_instruction-start_time').val(dislplay_time);
            $('#operation_instruction-start_time-value').val(dislplay_time);
        } else {
            var dt = new Date($(this).val());
            var newTs = dt.getTime() - (elapsed_time_total * 60 * 1000);
            $('#operation_instruction-start_time').val(createDateStr(newTs));
        }
    });

    $(document).on('change','#operation_instruction-end_time-value', function(){
        var timeStr = $(this).val();
        var [hours, minutes] = timeStr.split(':').map(Number);
        var newTs = ((hours * 60) + minutes) - elapsed_time_total;
        var dislplay_time = createTimeStr(newTs);
        $('#operation_instruction-end_time').val(dislplay_time);
        $('#operation_instruction-end_time-value').val(dislplay_time);
    });


    $(document).on('change','.elapsed_time_form', function(){
        calculateElapsedTime();
        if ($(this).hasClass('route_master_form')) {
            var timeStr = $('#operation_instruction-start_time').val();
            var [hours, minutes] = timeStr.split(':').map(Number);
            var newTs = ((hours * 60) + minutes) + elapsed_time_total;
            var dislplay_time = createTimeStr(newTs);
            $('#operation_instruction-end_time').val(dislplay_time);
            $('#operation_instruction-end_time-value').val(dislplay_time);
        } else {
            var dt = new Date($('#operation_instruction-start_time').val());
            var newTs = dt.getTime() + (elapsed_time_total * 60 * 1000);
            $('#operation_instruction-end_time').val(createDateStr(newTs));
        }
    });

    // データの変更が行われたらフラグを立てる
    let changedFlg = false;
    $(document).on('change', '.form_parts', function(e){
        changedFlg = true;
    });

    // 戻るボタン
    $(document).on('click', '#operation_instruction-revise_route', function(e) {
        e.preventDefault();
        e.stopPropagation();
        if(changedFlg) {
            if (!confirm('変更が保存されておりませんが\n一覧に戻りますか？')) {
                return false;
            } else {
                window.location.href = $(this).data('url');
            }
        } else {
            window.location.href = $(this).data('url');
        }
    });

    // 削除ボタン
    $(document).on('click', '#operation_instruction-delete_btn', function(e) {
        e.preventDefault();
        e.stopPropagation();
        if (!confirm('削除します。\nよろしいですか？')) {
            return false;
        } else {
            // ポスト送信を実行（削除）削除処理を作ったら修正
            let datas = $('#operation_instruction-form').serializeArray();
            _ajax.post($(this).data('url'), datas, function(response) {
                window.location.href = response.return_url;
            }, function(xhr, status, errorThrown){
                _error.omitted(xhr, status, errorThrown);
            });
        }
    });

    $(document).on('click', '#operation_instruction-submit', function(e){
        // 親要素へのクリックイベント伝搬を回避する
        e.preventDefault();
        e.stopPropagation();
        // 保存処理へデータ送信

        // アクションの取得
        let action = extend_url_query($('#operation_instruction-form').data('action'));
        // 検索フォームを配列化
        let datas = $('#operation_instruction-form').serializeArray();

        datas.push(
            {name: 'holding_id', value: $('#user-holding-config').children('span').data('replace-name-holding-id')},
            {name: 'company_id', value: $('#user-company-config').children('span').data('replace-name-company-id')},
            {name: 'section_id', value: $('#user-section-config').children('span').data('replace-name-section-id')},
        );
        // ポスト送信を実行
        _ajax.post(action, datas, function(response) {
            changedFlg = false;
            load_contents();
        }, function(xhr, status, errorThrown){
            _error.omitted(xhr, status, errorThrown);
        });
    });

    // 地図用の要素がリサイズされた場合に地図を表示しなおす
    $(window).on('resize', function(){
        clearTimeout(timerId);
        timerId = setTimeout(() => {
            resizeMap();
        }, 200);
    });
}

window.operation_instruction_setting_map_set = function() {

    // 経由地の数
    let way_point_index = 0;

    $('div.content-wrapper').css('min-height','100%');
    //map
    zMapMain = $('#instruction_map').find('.video-map');

    // 簡易経路データ
    RouteData = $('#instruction_map').find('.video-map').data('route_data');

    // 経路の線データ
    lineData = $('#instruction_map').data('link_data');

    //詳細経路データ
    route_list = $('#instruction_map').find('.video-map').data('route_data');

    // 地図用の要素がリサイズされた場合に地図を表示しなおす
    $(window).on('resize', function(){
        clearTimeout(timerId);
        timerId = setTimeout(() => {
            adjustMapZoom();
        }, 200);
    });

    //経由地を追加
    $(document).on('click', '#add_waypoint', function(){
        let way_point = $('#waypoint_original').clone();
        way_point.find('input').each(function(){
            let name = $(this).attr('name');
            $(this).attr('name', `${name}[${way_point_index}]`);
            let id = $(this).attr('id');
            $(this).attr('id', `${id}[${way_point_index}]`);
        });

        way_point.find('select').each(function(){
            let name = $(this).attr('name');
            $(this).attr('name', `${name}[${way_point_index}]`);
            let id = $(this).attr('id');
            $(this).attr('id', `${id}[${way_point_index}]`);
        });
        way_point.find('.select2-selection').remove();
        $(this).before('<div class="row py-2 waypoint_box place_input_box mt-2">'+way_point.html()+'</div>');
        way_point_index++;
        initialize_select2();
        $(this).prev('div.waypoint_box').find('span.select2').hide();
    });

    // 経由地を削除
    $(document).on('click', '.delete_waypoint', function(){
        // 該当の経由地を削除
        $(this).parents('.waypoint_box').remove();
        //他の経由地に振られているキー値を振りなおす
        way_point_index = 0;
        $('.waypoint_box').each(function(index) {
            $(this).find('input').each(function(){
                let name = $(this).attr('name').replace(/\[\d+\]$/, '');
                $(this).attr('name', `${name}[${way_point_index}]`);
            });

            $(this).find('select').each(function(){
                let name = $(this).attr('name').replace(/\[\d+\]$/, '');
                $(this).attr('name', `${name}[${way_point_index}]`);
            });
            way_point_index++;
        });
        //経路線の振り直し
        createRouteData();
        if(RouteData.length > 0) {
            deleteRouteData();
            drawRouteData();
            adjustMapZoom();
        }
    });

    $(document).on('click','.radio_destination', function() {
        $(this).parent().parent().next('div').find('input.address_input').prop("disabled", true);
        $(this).parent().next('div').find('select.destination_select').prop("disabled", false);
    });
    $(document).on('click','.radio_address', function() {
        $(this).parent().parent().prev('div').find('select.destination_select').prop("disabled", true);
        $(this).parent().next('div').find('input.address_input').prop("disabled", false);
    });

    // 行先マスタから検索
    $(document).on('change', 'select.destination_select', function(){
        let form_lat = $(this).parent().parent().siblings('.form_lat');
        let form_lon = $(this).parent().parent().siblings('.form_lon');
        let form_address = $(this).closest('div.row').nextAll('div.row').find('.address_input').first();

        form_lat.val($(this).find('option:selected').data('latitude'));
        form_lon.val($(this).find('option:selected').data('longitude'));
        form_address.val($(this).find('option:selected').text());

        _zdcMap._zMap.moveLatLon(new ZDC.LatLon(form_lat.val(), form_lon.val()));
        route_search_flg = true;
        deleteRouteData();
        createRouteData();
        drawRouteData();
        adjustMapZoom();
    });

    //　住所から検索
    $(document).on('click', '.address_search-btn', function(){
        let val = $(this).closest('div').siblings('div').find('.address_input').first().val();
        let form_lat = $(this).parent().parent().siblings('.form_lat');
        let form_lon = $(this).parent().parent().siblings('.form_lon');
        // 入力なしは何もしない
        if (val.length === 0) {
            return;
        }
        // OAuthパラメタ取得
        let apiName = 'address/word';
        let data = {
            api: apiName,
            word: val,
            limit: 1
        };
        _ajax.post(_zdcMap._mapApiUrl, data, function (result) {
            ZDC.Search.getByZmaps(apiName, result.params, function (status, res) {
                if (status.code === 200 && res.info.hit > 0) {
                    _zdcMap._zMap.moveLatLon(new ZDC.LatLon(res.item[0].point.lat, res.item[0].point.lon));
                    form_lat.val(res.item[0].point.lat);
                    form_lon.val(res.item[0].point.lon);
                    deleteRouteData();
                    createRouteData();
                    drawRouteData();
                    adjustMapZoom();
                    route_search_flg = true;
                }
            });
        }, function (xhr, status, errorThrown) {
            _error.omitted(xhr, status, errorThrown);
        });
    });

    //ルート検索設定
    $(document).on('click', '.route_setting_btn', function(e){

    });

    // 運行指示書作成ボタン
    $(document).on('click', '#operation_instruction_instruction-submit', function(e){
        // 親要素へのクリックイベント伝搬を回避する
        e.preventDefault();
        e.stopPropagation();
        // 保存処理へデータ送信

        if(create_flg) {
            // アクションの取得
            let action = extend_url_query($('#operation_instruction-form').data('action'));
            let record_id = $('#operation_instruction-id').val();
            // 検索フォームを配列化
            let datas = {
                id: record_id,
                holding_id:$('#user-holding-config').children('span').data('replace-name-holding-id'),
                company_id:$('#user-company-config').children('span').data('replace-name-company-id'),
                section_id:$('#user-section-config').children('span').data('replace-name-section-id'),
                route_list: route_list,
                link_data: JSON.stringify(link_data),
                _token: $('meta[name="csrf-token"]').attr('content'),
                instruction_flg: true
            };
            // ポスト送信を実行
            _ajax.post(action, datas, function(response) {
                window.location.href = response.return_url;
            }, function(xhr, status, errorThrown){
                _error.omitted(xhr, status, errorThrown);
            });
        } else {
            toastr.warning("ルート検索を先に行ってください。");
        }
    });

    // 経路マスタ作成ボタン
    $(document).on('click', '#operation_instruction_master-submit', function(e){
        // 親要素へのクリックイベント伝搬を回避する
        e.preventDefault();
        e.stopPropagation();
        // 保存処理へデータ送信
        if(create_flg) {
            // アクションの取得
            let action = extend_url_query($('#operation_instruction-form').data('action'));
            let record_id = $('#operation_instruction-id').val();
            // 検索フォームを配列化
            let datas = {
                id: record_id,
                holding_id:$('#user-holding-config').children('span').data('replace-name-holding-id'),
                company_id:$('#user-company-config').children('span').data('replace-name-company-id'),
                section_id:$('#user-section-config').children('span').data('replace-name-section-id'),
                route_list: route_list,
                link_data: JSON.stringify(link_data),
                _token: $('meta[name="csrf-token"]').attr('content'),
                route_master_flg: true
            };

            // ポスト送信を実行
            _ajax.post(action, datas, function(response) {
                window.location.href = response.return_url;
            }, function(xhr, status, errorThrown){
                _error.omitted(xhr, status, errorThrown);
            });
        } else {
            toastr.warning("ルート検索を先に行ってください。");
        }
    });

    // ルート検索ボタン
    $(document).on('click', '#route_search_btn', function(){
        if(route_search_flg) {
            let from;
            let to;
            let action = $(this).data('url');
            let datas = [];
            let mpoints = [];

            $.each(RouteData, function(num, item){
                if(num==0) {
                    from = new ZDC.LatLon(item.latitude, item.longitude);
                } else if(num==RouteData.length-1){
                    to = new ZDC.LatLon(item.latitude, item.longitude);
                } else {
                    mpoints.push(item.latitude);
                    mpoints.push(item.longitude);
                }
            });
            datas = {
                from_code: from.lat + ',' + from.lon,
                to_code: to.lat + ',' + to.lon,
                _token: $('meta[name="csrf-token"]').attr('content'),
                route_data: RouteData,
            };
            if(mpoints.length > 0) {
                datas['mpoints'] = mpoints.join(',');
            }

            _ajax.post(action, datas, function(results) {
                let resultParse = JSON.parse(results);
                link_data = resultParse.route;

                deleteRouteData();

                link_data.forEach(link =>{
                    for (var k=0, l=link.line.latlon.length; k<l; k+=2) {
                        polylineLociLatlon.push(new ZDC.LatLon(String(link.line.latlon[k]),String(link.line.latlon[k+1])));
                    }
                });
                polylineLoci = new ZDC.Polyline(
                    polylineLociLatlon,
                    {
                        strokeColor: '#669DF6',
                        strokeWeight: 3,
                        closePath: false,
                    }
                );
                _zdcMap._zMap.addWidget(polylineLoci);

                route_list = resultParse.route_list;
                let total_time = 0;
                let start_time =  9*60;
                createMarkerAndMassage(start_time,total_time);

                if(resultParse.route_list_view) {
                    $(".route_data").remove();
                    $(".route_data_table").append(resultParse.route_list_view);
                }
                create_flg = true;
            },function(xhr, status, errorThrown){
                var responseText = JSON.parse(xhr.responseText);
                toastr.warning(responseText.text);
            },'html');
        } else {
            toastr.warning("地点の検索を先に行ってください。");
        }
    });

    // 地図：初期表示
    setTimeout(function(){
        createMap();
        if(lineData) {
            drawDirectionRouteData();
        }
        adjustMapZoom();
    },1000);

    // 戻るボタン
    $(document).on('click', '#operation_instruction-revise_route', function(e) {
        e.preventDefault();
        e.stopPropagation();
        window.location.href = $(this).data('url');
    });
}

// モーダル上に地図を生成
function createMap() {
    let options = {
        addressOfMarker: false,
        zoom: 11,
        mapType: ZDC.MAPTYPE_COLOR,
    };
    if (zMapMain.length > 0) {
        zMapMain.empty();
        //地図を作成
        zMapMain.attr('width', zMapMain.width() + 'px');
        zMapMain.attr('height', zMapMain.height() + 'px');
        if (zMapMain.data('zip_lat') !== '' || zMapMain.data('zip_lon') !== '') {
            options.lat = zMapMain.data('zip_lat');
            options.lon = zMapMain.data('zip_lon');
        }
        _zdcMap.Map.init(zMapMain, options, false);

        /* 地図にイベントを追加 */
        ZDC.addListener(_zdcMap._zMap, ZDC.MAP_CHG_LATLON, onMarkerChangeMap);
        ZDC.addListener(_zdcMap._zMap, ZDC.MAP_CHG_ZOOM, onMarkerChangeMap);
        ZDC.addListener(_zdcMap._zMap, ZDC.MAP_MOUSEMOVE, onMarkerMouseMove);
        ZDC.addListener(_zdcMap._zMap, ZDC.MAP_MOUSEUP, onMarkerMouseUp);

        /* documentにイベントを追加 */
        ZDC.addDomListener(document, 'mouseup', onMarkerMouseUp);
    }
}

//経路データの罫線とマーカを地図上に配置する
function drawRouteData () {
    polylineLoci = false;
    polylineLociLatlon = [];
    if(RouteData.length > 0) {
        //地図上に経路の線を引く
        $.each(RouteData, function(i, item){
            if(item.route_type=='STR' || item.route_type=='END' || item.route_type=='VIA') {
                polylineLociLatlon.push(new ZDC.LatLon(item.latitude, item.longitude));
            }
        });

        polylineLoci = new ZDC.Polyline(
            polylineLociLatlon,
            {
                strokeColor: '#669DF6',
                strokeWeight: 3,
                closePath: false,
            }
        );

        _zdcMap._zMap.addWidget(polylineLoci);

        $.each(RouteData, function(i, item){
            if(item.route_type=='STR' || item.route_type=='END' || item.route_type=='VIA') {
                //地図上にマーカーを描く
                marker[i] = new ZDC.Marker(
                    new ZDC.LatLon(item.latitude, item.longitude),
                    {
                        color: ZDC.MARKER_COLOR_ID_GREEN_L,
                        /*
                        // マーカのサイズに合わせて位置を調整する
                        offset: new ZDC.Pixel(-17, -32),
                        custom: {
                            base : {
                                src: '../../../assets/img/icon_event.png'
                            }
                        }
                        */
                    }
                );
                _zdcMap._zMap.addWidget(marker[i]);

                if(drag_flg) {
                    ZDC.addListener(marker[i], ZDC.MARKER_MOUSEMOVE, (function(mrk,i) {
                        return function() {
                            onMarkerMouseMove(mrk);
                        };
                    })(marker[i],i))
                    ZDC.addListener(marker[i], ZDC.MARKER_MOUSEDOWN, (function(mrk,i) {
                        return function() {
                            mkrLatLon = new ZDC.LatLon($('.operation_instruction-lat').eq(i).val(),$('.operation_instruction-lon').eq(i).val());
                            onMarkerMouseDown(mrk);
                        };
                    })(marker[i],i));
                    ZDC.addListener(marker[i], ZDC.MARKER_MOUSEUP, (function(i) {
                        return function() {
                            onMarkerMouseUp(i);
                        };
                    })(i));
                }
            }
        });
    }
}

//経路データの罫線とマーカを地図上に配置する
function drawDirectionRouteData () {
    polylineLoci = false;
    polylineLociLatlon = [];
    if(lineData.length > 0) {
        //地図上に経路の線を引く
        $.each(lineData, function(i, item){
            polylineLociLatlon.push(new ZDC.LatLon(item.line.latlon[0], item.line.latlon[1]));
            polylineLociLatlon.push(new ZDC.LatLon(item.line.latlon[2], item.line.latlon[3]));
        });
        polylineLoci = new ZDC.Polyline(
            polylineLociLatlon,
            {
                strokeColor: '#669DF6',
                strokeWeight: 3,
                closePath: false,
            }
        );
        _zdcMap._zMap.addWidget(polylineLoci);
    }
    if(RouteData.length > 0) {
        let start_time = 0;
        let total_time = 0;
        //地図上にマーカーを描く
        if($('#operation_instruction-start_time').length) {
            var timeStr = $('#operation_instruction-start_time').val();
            if ($('#operation_instruction-start_time').hasClass('route_master_form')) {
                // ルート検索
                var [hours, minutes] = timeStr.split(':').map(Number);
                start_time = hours*60 + minutes;
            } else {
                // 運行指示書
                dt = new Date($('#operation_instruction-start_time').val());
                start_time =  (dt.getHours()*60) + dt.getMinutes();
            }
        } else {
            // ルート検索
            start_time =  9*60; // 09:00で一旦固定
        }
        total_time = 0;
        createMarkerAndMassage(start_time,total_time);
    }
}

// 経路データを削除する
function deleteRouteData() {
    if(polylineLoci) {
        _zdcMap._zMap.removeWidget(polylineLoci);
    }
    polylineLoci = false;
    polylineLociLatlon = [];

    if(marker) {
        $.each(marker, function(i, item){
            if(item) {
                _zdcMap._zMap.removeWidget(item);
            }
        });
    }
    marker = [];

    if(msg) {
        $.each(msg, function(i, item){
            if(item) {
                item.close();
                _zdcMap._zMap.removeWidget(item);
            }
        });
    }
    msg = [];

}

// 配置したマーカー、走行軌跡に合わせて地図の中央位置およびズーム倍率を自動調整します。
function adjustMapZoom(){

    let points = [];
    if(marker.length > 0) {
        $.each( Object.values(marker), function ( i, item ) {
            if(item) {
                points.push(item.getLatLon());
            }
        });
    }
    if(msg.length > 0) {
        $.each( Object.values(msg), function ( i, item ) {
            if(item) {
                points.push(item.getLatLon());
            }
        });
    }
    $.each( Object.values(polylineLociLatlon), function ( i, latlon ) {
        points.push(latlon);
    });

    if(points.length > 0){
        let adjusts = _zdcMap._zMap.getAdjustZoom(points);
        if (adjusts) {
            if(adjusts.zoom > 0) {
                adjusts.zoom = adjusts.zoom-1;
            }
            setTimeout(function(){
                _zdcMap._zMap.setZoom(adjusts.zoom);
                _zdcMap._zMap.setHome(new ZDC.LatLon(adjusts.latlon.lat,adjusts.latlon.lon));
                _zdcMap._zMap.moveLatLon(new ZDC.LatLon(adjusts.latlon.lat,adjusts.latlon.lon));
            },100);
        }
    }
}

// 吹き出し付きのマーカーを作成する
function createMarkerAndMassage(start_time, total_time) {
    let n = 1;
    $.each(route_list, function(i, item) {
        if(item.route_type != 'RUN' && item.type != 'run') {
            let key  = `MARKER_NUMBER_ID_${n}_S`;
            let markerId = ZDC[key];
            marker[i] = new ZDC.Marker(
                new ZDC.LatLon(item.latitude, item.longitude),
                {
                    // マーカのサイズに合わせて位置を調整する
                    color:ZDC.MARKER_COLOR_ID_BLUE_S,
                    number:markerId,
                }
            );
            _zdcMap._zMap.addWidget(marker[i]);

            /* 吹き出しを作成 */
            let msgTxt  = "";
            if(item.facility) {
                time3 = parseInt(item.time3);
                msgTxt = "<div>No."+ n +" 【" + item.facility + "】</div>";
                if(i <= 0) {
                    msgTxt += "<div>出発時刻：" + createTimeStr(time3) + "</div>";
                } else {
                    if(i == RouteData.length-1) {
                        msgTxt += "<div>到着時刻：" + createTimeStr(start_time) + "</div>";
                    } else {
                        msgTxt += "<div>到着時刻：" + createTimeStr(start_time) + "</div>";
                        start_time += time3;
                        msgTxt += "<div>出発時刻：" + createTimeStr(start_time) + "</div>";
                    }
                }
                total_time += time3;
            }else{
                msgTxt = "<div>No."+ n +" 【" + item.place_name + "】</div>";
                if(i > 0) {
                    msgTxt += "<div>到着時刻：" + createTimeStr(start_time) + "</div>";
                }
                if(i < RouteData.length-1) {
                    start_time += ((item.hour * 60) + item.minutes);
                    msgTxt += "<div>出発時刻：" + createTimeStr(start_time) + "</div>";
                }
                total_time += ((item.hour * 60) + item.minutes);
            }

            msgTxt += "<div>経過時間：" + conversionTime(total_time)+ "</div>";
            msg[i] = new ZDC.MsgInfo(new ZDC.LatLon(item.latitude, item.longitude),
                {
                    html: msgTxt,
                    offset: ZDC.Pixel(0, -18)
                });
            /* 吹き出しを追加 */
            _zdcMap._zMap.addWidget(msg[i]);
            msg[i].setZindex(110);
            msg[i].open();

            // 吹き出しの凹み補正
            zMapMain.find('img[src*="msginfo.png"]').each(function(){
                let $div = $(this).parent().parent().parent();
                if( $div.width()>0 && $div.parent().width() > 0 && !$div.hasClass("resized") ){
                    $div.width( $div.width()+18 );
                    $div.addClass("resized");
                }
            });
            msg[i].close();

            /* マーカがクリックされたら吹き出しを表示する関数を実行させる */
            ZDC.addListener(marker[i], ZDC.MARKER_MOUSEUP, function(){
                msg[i].open();
            });
            n++;
        } else {

            if(item.time3) {
                time3 = parseInt(item.time3);
                start_time += time3;
                total_time += time3;
            }else {
                start_time += ((item.hour * 60) + item.minutes);
                total_time += ((item.hour * 60) + item.minutes);
            }
        }
    });
}

// 地図をリサイズする
function resizeMap() {
    let options = {
        addressOfMarker: false,
        zoom: 11,
    };
    if (zMapMain.length > 0) {
        //地図を作成
        zMapMain.attr('width', zMapMain.width() + 'px');
        zMapMain.attr('height', zMapMain.height() + 'px');
        _zdcMap._zMap.refresh();
    }
}

// 経路情報一覧テーブルの内容を変更する
function changeRouteDataList() {
    $('.route_data_record').remove();
    let $tableData = "";
    $.each(RouteData, function(i, item){
        $tableData += '<tr class="route_data_record">';
        if(item.start_time) {
            $tableData += '<td>' + item.start_time + '</td>';
            $tableData += '<td>' + item.type_name + '</td>';
            $tableData += '<td>' + item.hour +'時間 '+ item.minutes+ '分' + '</td>';
            if(item.place_name == null) {
                $tableData += '<td></td>';
            } else {
                $tableData += '<td>' + item.place_name + '</td>';
            }
        } else {
            if(item.type =='VIA') {
                $tableData += '<td>' + item.work_name + '</td>';
            } else {
                $tableData += '<td>' + item.type_name + '</td>';
            }
            $tableData += '<td>' + item.hour +'時間 '+ item.minutes+ '分' + '</td>';
            if(item.place_name == null) {
                $tableData += '<td></td>';
            } else {
                $tableData += '<td>' + item.place_name + '</td>';
            }
        }
        $tableData += "</tr>";
    });
    $('.route_data_table tbody').append($tableData);
}

// 日時用の文字列作成
function createDateStr(newTs) {
    var newDt = new Date(newTs);
    var y = newDt.getFullYear();
    var M = pad(newDt.getMonth()+1);
    var d = pad(newDt.getDate());
    var h = pad(newDt.getHours());
    var m = pad(newDt.getMinutes());
    return y + '/' + M + '/' + d + ' ' + h + ':' + m;
}

// 時間用の文字列作成
function createTimeStr(newTs) {
    if(newTs < 0) {
        newTs = newTs * -1;
    }
    var h = pad(Math.floor(newTs / 60));
    if(h > 23) {
        h = h - 24;
    }
    var m = pad(newTs % 60);
    return h + ':' + m;
}

//時間変換(分を時分へ)
function conversionTime(time) {

    time = Math.ceil(time);
    hour =  Math.floor(time / 60);

    day = 0;
    if(hour >= 24) {
        day = Math.floor(hour/24);
        hour = hour%24;
    }
    minute =  time % 60;

    if(day >= 1) {
        return day + '日' + hour + '時間' + minute + '分';
    } else {
        return hour + '時間' + minute + '分';
    }
}

// 0パディング
function pad(n) {
    return n<10 ? '0'+n : n;
}

// 経路情報上の所要時間を計算する
function calculateElapsedTime() {
    elapsed_time_total = 0;
    $(".elapsed_time_box").each(function(i, elm){
        elapsed_time_total = elapsed_time_total + Number($(elm).data('minute'));
    });

    $(".elapsed_time_form").each(function(i, elm){
        elapsed_time_total = elapsed_time_total + Number($(elm).val());
    });
}

/***** マーカー移動関係 *****/

/* マウスダウンイベント処理 */
function onMarkerMouseDown(mrk) {
    /* マウスダウン位置の緯度経度とマーカの緯度経度の差分を保持 */

    var cLatLon = _zdcMap._zMap.getPointerPosition();
    if(mrk) {
        difLat = cLatLon.lat - mkrLatLon.lat;
        difLon = cLatLon.lon - mkrLatLon.lon;
        dragging = true;
    }
}

/* マウスムーブイベント処理 */
function onMarkerMouseMove(mrk) {
    /* ドラッグ中のみ処理させる */
    if(dragging && mrk) {
        var latlon = _zdcMap._zMap.getPointerPosition();

        /* マーカ表示緯度経度を取得 */
        var mkLat = latlon.lat - difLat;
        var mkLon = latlon.lon - difLon;
        mkrLatLon = new ZDC.LatLon(mkLat, mkLon);
        mrk.moveLatLon(mkrLatLon);

        if(pointerOut()){
            if(timer==null){
                timer = setInterval(movemap, 10);
            }
        }
    }
}

/* マウスアップイベント処理 */
function onMarkerMouseUp(i) {
    if(dragging) {
        dragging = false;
        clearTimer();
        $('.operation_instruction-lat').eq(i).val(mkrLatLon.lat);
        $('.operation_instruction-lon').eq(i).val(mkrLatLon.lon);
        setAddressValue(mkrLatLon.lat,mkrLatLon.lon,i);
    }
}

/* 地図移動時の処理 */
function onMarkerChangeMap() {
    //地図表示領域より20pxくらい小さいBOXを持っておく
    var tl = _zdcMap._zMap.tlToLatLon(ZDC.TL(20 , 20));
    var tr = _zdcMap._zMap.tlToLatLon(ZDC.TL(20 , 730));
    var br = _zdcMap._zMap.tlToLatLon(ZDC.TL(480 , 730));
    var bl = _zdcMap._zMap.tlToLatLon(ZDC.TL(480 , 20));
    llbox = new ZDC.LatLonBox(bl , tr);
}

/* 内枠の内外判定 */
function pointerOut() {
    //var point = mrk.getLatLon();//mrkの位置だとイベントの位置が取りにくい
    var point = _zdcMap._zMap.getPointerPosition();

    if(ZDC.isPolygonContainLatLon(point, latlons)){
        clearTimer();
        return false;
    }else{
        if(llbox.getMin().lat > point.lat){
            //下にはみ出た
            direction = 'down';
        }else if(llbox.getMax().lat < point.lat){
            //上にはみ出た
            direction = 'up';
        }else if(llbox.getMin().lon > point.lon){
            //左にはみ出た
            direction = 'left';
        }else if(llbox.getMax().lon < point.lon){
            //右にはみ出た
            direction = 'right';
        }
        return true;
    }
};

function movemap(){
    if(direction == 'down'){
        _zdcMap._zMap.movePx(0,amount);
    }else if(direction == 'up'){
        _zdcMap._zMap.movePx(0,amount*-1);
    }else if(direction == 'left'){
        _zdcMap._zMap.movePx(amount*-1,0 ,0);
    }else if(direction == 'right'){
        _zdcMap._zMap.movePx(amount, 0);
    }
};

function clearTimer(){
    if(timer!=null){
        clearInterval(timer);
        timer=null;
    }
};

function setAddressValue(latitude, longitude,num){
    let apiName = 'location';
    let data = {
        api: apiName,
        latlon: latitude + ',' + longitude
    };
    _ajax.post(_zdcMap._mapApiUrl, data, function (result) {
        ZDC.Search.getByZmaps(apiName, result.params, function (status, res) {
            if (status.code == '200' &&  res && res[0]) {
                $('input.address_input').eq(num).val(res[0].address['text']);
                $('input.address_input').eq(num).prop('disabled',false);
                $('select.destination_select').eq(num).prop('disabled',true);
                $('input.address_input').eq(num).parent('div').prev('.radio_box').find('.radio_address').prop('checked', true);
                deleteRouteData();
                createRouteData();
                drawRouteData();
            }
        });
    });
}

function createRouteData() {
    let num = 0;
    RouteData = [];
    $('.place_input_box').each(function(index) {
        let lat = $(this).find('.form_lat').val();
        let lon = $(this).find('.form_lon').val();
        let destination_id = null;
        if(!$(this).find('.destination_select').prop('disabled')) {
            destination_id = $(this).find('.destination_select').val();
        }
        let place_name = $(this).find('.address_input').val();
        let work_time = 0;
        let work_type = 0;
        let route_type = '';
        if(lat.length > 0 && lon.length > 0) {
            if(index > 0 && $('input.time_input').eq(index-1).val()) {
                work_time = $('input.time_input').eq(index-1).val();
            }
            if(index > 0 && $('select.waypoint-work_type').eq(index-1).val()) {
                work_type = $('select.waypoint-work_type').eq(index-1).val();
            }
            if(num == 0) {
                route_type = 'STR';
            }else if(num == $('.place_input_box').length-1) {
                route_type = 'END';
                work_time = 0;
            } else {
                route_type = 'VIA';
            }
            RouteData[num] = {
                latitude: lat,
                longitude: lon,
                destination_id: destination_id,
                place_name: place_name,
                work_time: work_time,
                work_type: work_type,
                route_type: route_type
            };
            num++;
        }
    });
}
